<template lang="pug">
  div
    div.row.justify-content-center(style="padding-top:15px;")
      div.col-12.col-lg-11
        div.row.justify-content-center
          div.col
            div.card#terms
              div.card-header(style="text-align:left;")
                h5.d-inline-flex(style="margin-bottom:0px;")
                  font-awesome-icon(icon="scroll", style="margin-right: 5px;")
                  | Terms - 特定商取引法に基づく表記
              div.card-body(style="padding-bottom: 14px; min-height: 140px;")
                table.table
                  tbody
                    tr
                      td 販売業者
                      td 沖縄エクスカージョンズ株式会社
                    tr
                      td 代表者
                      td 護得久朝晃
                    tr
                      td 所在地
                      td
                        | 〒903-0807
                        br
                        | 沖縄県那覇市久場川町2-30-2
                    tr
                      td 電話番号
                      td 098-988-1114
                    tr
                      td メールアドレス	
                      td info@gokakuessay.com
                    tr
                      td URL
                      td http://gokakuessay.com
                    tr
                      td 販売価格
                      td 商品紹介ページをご参照ください。
                    tr
                      td 対応ソフト
                      td Google Chrome, Chromium, Adobe Acrobat, Adobe Acrobat Reader
                    tr
                      td 商品代金以外の必要料金	
                      td 消費税
                    tr
                      td お支払方法	
                      td クレジットカード
                    tr
                      td 返品・交換・キャンセル等
                      td サービスの性質上、返品・返金はお受けしておりません。

</template>

<script>

export default {
  name: 'Terms',
  components: {
  },
  head: {
    title: {
      inner: 'Terms'
    },
    meta: [
      { name:"robots", content:"none"},
      { name:"description", content:""}
    ]
  },
  data (){
      return {}
  },
  mounted (){
  },
  methods:{
  }
}
</script>




<style scoped>
tr td:first-child {
  background-color:darkseagreen;
}

</style>
